import conf from "./config";
import { cleanToken } from "./storage";

const auth = function () {
  if(conf.auth) return;
  conf.auth = true;
  cleanToken();
  let redirect_uri = encodeURIComponent(location.href);
  let state = location.pathname + location.search;
  let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${conf.appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`
  location.href = url;
};

export default auth;
